export default __webpack_public_path__ + "static/Paragraph-47a22c087307bf98e19b3700fb20d20b.jpg";